import { usePopup } from 'hooks/usePopup';
import { useSoundPath } from 'hooks/useSoundPath';
import { useDispatch, useSelector } from 'react-redux';
import { setactiveItem } from 'store/cards';
const ActiveItemClose = () => {
  const dispatch = useDispatch();
  const {isVisible} = useSelector((state) => state.popups);
  const setPopupHook = usePopup();
  const playSound = useSoundPath();

  const closeItem = () => {
    playSound('main');
    dispatch(setactiveItem(null))
    if (isVisible) {
      setPopupHook('close');
    }
  }

  return (
    <button
      className='card-details__title-close'
      onClick={closeItem}
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 9L9 15M15 15L9 9M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#ffffff" strokeWidth="1.4" strokeLinecap="square" />
      </svg>
    </button>
  )
}

export default ActiveItemClose;
